import { ModelAnswerList, ObPointMeasurementVM, SchematicListVM } from "../../favourite-dialog/favourite-dialog-modal";


export class CurrentSelection {
  public equipment: Equipment = new Equipment();
  public jobSite: JobSite = new JobSite();
  public customer: Customer = new Customer();
  public family: Family = new Family();
  public make: Make = new Make();
  public model: Model = new Model();
}
export class SelectionLists {
  public customerList: Customer[] = [];
  public jobSiteList: JobSite[] = [];
  public equipmentList: Equipment[] = [];
  public familyList: Family[] = [];
  public makeList: Make[] = [];
  public modelList: Model[] = [];
  public SitecodeList: SiteCodes[] = [];
}
export class Equipment {
  public Id: number = 0;
  public JobSiteId: number = 0;
  public Serial: string = "";
  public Unit: string = "";
}
export class ComponentType {
  public Id: number = 0;
  public Name: string = "";
  public Selected: boolean = false;
}

export class ModelSelected {
  public Id: number = 0;
  public Name: string = "";
  public Selected: boolean = false;
}

export class JobSite {
  public Id: number = 0;
  public CustomerId: number = 0;
  public Title: string = "";
}
export class Customer {
  public Id: number = 0;
  public Title: string = "";
}

export class Family {
  public Id: number = 0;
  public Title: string = "";
  public Symbol: string;
}
export class Make {
  public Id: number = 0;
  public Symbol: string = "";
  public Title: string = "";
}
export class Model {
  public Id: number = 0;
  public MakeId: number = 0;
  public FamilyId: number = 0;
  public ExistingCount = 0;
  public Title: string = "";
}
export class GlobalLabels {
  currentPageTitle: string = "";
  currentPageHeader: string = "";
  backRoute: string = "";
}
export class PageSetting {
  public Id: number;
  public pageId: number;
  public pageTitle: string;
}
export class PageComponentList {
  public pageId: number;
  public childComponentSelector: string;
  public included: boolean = false;
}

export class DataIdName {
  public Id: number;
  public Name: string;
}

export class Task5Model {
  public inputValueMonth: number;
  public inputValueYear: number;
  public inputValuenumber: number;
  public inputValuestate: number;
}

export class ToolboxTalkModel {
  public inputValueMonth: number;
  public inputValueYear: number;
  public inputValuenumber: number;
  public inputValuestate: number;
}

export class MonthlyDashboardMessageVM {
  public Month: number;
  public Year: number;
  public FocusItems: string;
  public AreasImprovement: string;
  public Positives: string;
  public Take5Target: number;
  public SafetyInspTarget: number;
  public inputValuestate: number;
}

export class GetMonthlyTargetListVM {
  public ID: number;
  public AddedByUser: number;
  public Month: number;
  public Year: number;
  public Take5Target: number;
  public SafetyInspectionTarget: number;
  public SiteId: number;
  public Sort: number;

}

export class MonthlyHoursVM {
  public ID: number
  public AddedByUser: number
  public EditedUser: number
  public Month: number
  public Year: number
  public HoursForMonth: number
  public DateAdded: Date
  public EditedDate: Date
  public inputValuestate: number;
}
export class SiteCodes {
  public Id: number;
  public SiteName: string;
}
export class SiteCodeDetails {
  Id: number;
  Code: string;
  SiteName: string;
}

export class ChecklistCategoriesVM {
  ID: number
  CategoryName: string
  CategoryDescription: string
}

export class ChecklistQuestionsVM {
  ID: number
  QuestionName: string
  QuestionsDescription: string
  QuestionCategoryID: number
  ObservationTypeId: number
  Active: boolean
}

export class UpdatedCheckList {
  Category: ChecklistCategoriesVM
  Questions: ChecklistQuestionsVM[]
}

export class Department {
  public ID: number;
  public DepartmentName: string;
  public DepartmentDescription: string;
  public SiteId: number;
  public ObservationTypeId: number;
}
export class WorkArea {
  public ID: number;
  public WorkAreaName: string = "";
  public WorkAreaDescription: string = "";
  public DepartmentID: string = "";
  public Active: boolean;
  public SiteId: number;

}



export class DepartmentWorkAreasVM {
  public Departments: Department[] = []
  public WorkAreas: WorkArea[] = []
}

export class IncidentType {
  public ID: number;
  public Name: string = "";
  public Description: string = "";
  public Active: boolean
  public TRIFR: boolean
}
export class IdNameVM {
  public Id: number
  public Name: string
}
export class SafetyObservationsDashboardVM {
  public DashboardSummary: DashboardSummaryVM
  public CategorySummary: DashboardCategorySummaryVM[] = []
}
export class DashboardSummaryVM {
  public TotalInspections: number
  public TotalObservations: number
  public Failed: number
  public Passed: number
  public Incomplete: number
}
export class DashboardCategorySummaryVM {
  public CategoryName: string
  public Questions: DashboardQuestionSummaryVM[] = []
}
export class DashboardQuestionSummaryVM {
  public QuestionName: string
  public Safe: number
  public Unsafe: number
  public Unanswered: number
}
//overall dashboard models
export class OverallDashboardVM {
  public DaysSinceLastFail: number

  public OD_ChecksCompleted: OverallDashboard_ChecksCompleted;
  public OD_ChecksWithFails: OverallDashboard_ChecksWithFails;
  public OD_FailedItems: OverallDashboard_FailedItems;
  public OD_HoursToDate: OverallDashboard_HoursToDate;
  public OD_TRIFRTracking: OverallDashboard_TRIFRTracking;
  public OD_Messages: OverallDashboard_Messages;
  public OD_Take5s: OverallDashboard_Take5s;
  public OD_Activities: OverallDashboard_Activities;
  public OD_Incidents: OverallDashboard_Incidents;
  public OD_SafetyTargets: SafetyInspectionTargets;
}
export class OverallDashboard_ChecksCompleted {
  public Inspections: number;
  public InspectionQuestions: number;
}
export class OverallDashboard_ChecksWithFails {
  public ChecksFailed: number;
  public TotalChecks: number;
}
export class OverallDashboard_FailedItems {
  public FailedItems: number;
  public TotalItems: number;
}
export class OverallDashboard_HoursToDate {
  public HoursToDate: number;
  public DaysSinceLastIncidentMTIAndAbove: number;
  public DaysSinceLastLTI: number
}
export class TRIFRSummary {
  public Month: string
  public Total: number
  public TRIFR: number
}
export class OverallDashboard_TRIFRTracking {
  public LastThreeMonths: TRIFRSummary[] = []
  public Last12Month: TRIFRSummary
  public YTD: TRIFRSummary

}

export class OverallDashboard_Messages {
  public FocusItems: string;
  public Positives: string;
  public AreasOfImprovement: string
}

export class OverallDashboard_Take5s {
  public Target: number;
  public Actual: number;
  public CurrentActual: number
  public isCurrentMonth: boolean
}
export class DashboardNameTotals {
  public Name: string;
  public Total: number;
  public ID: number

}

export class OverallDashboard_Activities {
  public Activities: DashboardNameTotals[] = []
}

export class OverallDashboard_Incidents {
  public Incidents: DashboardNameTotals[] = []
}
export class SafetyInspectionTargets {
  public isCurrentMonth: boolean
  public Target: number
  public Expected: number
}

export class WorkAreasByDepartmentVM {
  public DepartmentId: number

  public DepartmentName: string
  public WorkAreas: IdNameVM[] = []

}

export class ObservationDetailsDomain {
  public ID: number;
  public UserID: number;
  public TaskObserved: string;
  public ObservationDate: Date;
  public WorkAreaID: number;
  public SiteId: number;
}

export class InspectionVM {

  public Id: number
  public CompletedDate: string
  public Department: string
  public DepartmentId: number
  public WorkArea: string
  public WorkAreaId: number
  public TaskObserved: string
  public Inspector: string
  public PersonsInvolved: number[] = []
  public QuestionCategories: QuestionCategoriesVM[] = []
  public ContractorsInvolved: number[]
  public SiteId: number;

}

export class QuestionCategoriesVM {
  public CategoryId: number
  public CategoryName: string
  public Questions: QuestionVM[] = []
  public HasNotApplicable: boolean;
}

export class QuestionVM {
  public ObservationQuestionId: number
  public QuestionId: number
  public QuestionName: string
  public SafeOrUnsafe: number
  public FollowUpRequired: boolean
  public FollowUpCompleted: boolean
  public QuestionComments: QuestionCommentsVM
  public QuestionImageList: QuestionImageVM[] = []

}

export class QuestionCommentsVM {
  public ActionObserved: string;
  public Responsibility: string;
  public FollowUpActions: string;
}

export class QuestionImageVM {
  public ID: number
  public ObQuestionID: number
  public Image: number[]

}


export class UsersVM {
  public UserAuto: number
  public UserId: string
  public UserName: string
  public suspended: boolean

}
export class ContractorsVM {
  public ID: number
  public ObservationDetailsId: number
  public ContractorCompanyName: string
  public ContractorStaffName: string
}
export class ObservationVMwithState {
  public ID: number
  public SiteId: number
}


export class saveImageVM {
  public Id: number
  public Image: string
  public imageID: number

}

export class ToggleFollowUpRequiredVM {
  public Id: number
  public Required: boolean
}

export class ToggleFollowUpCompletedVM {
  public Id: number
  public Completed: boolean
}

export class addPersonsInvolved {
  public InspectionID: number
  public selectedPersonsInvolved: number[]
}
export class FormGroupedByCategoryVM {
  public FormCategoryId: number
  public FormCategoryName: string
  public RequireIncidentNo: boolean
  public Froms: IdNameVM[]

}

export class FormUploadVM {

  public Id: number
  public DateCompleted: Date
  public Form: number
  public IncidentId: string
  public IncidentType: number
  public Images: string[]
  public FormFiles: string[]
  public File: string
  public FileName: string
  public RelatedUser: number
  public Notes: string
  public FollowUpRequired: boolean
  public FollowUpCompleted: boolean
  public FollowUpDate: Date
  public FollowUpUser: number
  public CreatedUser: number
  public CreatedDate: Date
  public ModifiedUser: number
  public ModifiedDate: Date
  public FormCatId: number
  public FormCatName: string
  public FormName: string
  public userName: string
  public CompletedDate: string
  public IncidentTypeName: string
  public IsDigitalForm: boolean
  public isSafety: boolean
  public SiteId: number
  public suspended: boolean
}

export class VMDataForUpload {
  public IsAdmin: boolean
  public AddUserLink: string
  public Users: UsersVM[];
  public Forms: FormGroupedByCategoryVM[];
  public IncidentTypes: IdNameVM[];
  public FormUploadData: FormUploadVM;
  public UpdateHistory: UpdateHistoryVM;

}

export class UpdateHistoryVM {
  public AddedByUser: string
  public DateAdded: string
  public ModifiedByUser: string
  public DateModified: string

}

export class GetEditDigitalFormVM {
  public AddUserLink: string
  public Users: UsersVM[]
  public Forms: FormGroupedByCategoryVM[]
  public IncidentTypes: IdNameVM[]
  public IsAdmin: boolean
  public FormUploadData: FormUploadVM
  public UpdateHistory: UpdateHistoryVM
  public FormCategories: DigitalFormQuestionsCategoriesVM[]
  public Questions: DigitalFormQuestionsVM[]
  public QuestionComments: DigitalFormQuestionComment[]
}

export class DigitalFormQuestionsCategoriesVM {
  public QuestionCatId: number
  public QCategoryName: string
  public FormId: number
  public Order: number
  public QuestionCount: number
  public IsParent: boolean
  public ParentCatId: number
  public ParentCatName: string;
  public SectionCount: number
  public Active: boolean;
  public NotStartCount: number;
  public CompleteCount: number;
  public InProgressCount: number;
  public CatStatus: string;
  public hasFlag: boolean;
}

export class DigitalFormQuestionsVM {
  public QuestionId: number;
  public QTitle: string
  public QDescription: string
  public Active: boolean
  public AllowImages: boolean
  public AllowComments: boolean
  public FormId: number;
  public QuestionTypeId: number;
  public HasQuestionImage: boolean
  public QuestionCatId: number;
  public Order: number;
  public ImageEdit: boolean
  public QuestionTypeName: string
  public QuestionNumber: number;
  public FormUploadId: number
  public QuestionImage: string
  public ModelAnswers: ModelAnswerList[];
  public UploadImages: string[]
  public EditedQuestionImage: string
  public QuestionComment: string
  public UnableToComplete: boolean;
  public UploadId: number;
  public inspectorId: number;
  public InspectorName: string;
  public Flag: boolean;
  public SchematicList: SchematicListVM[];
  public ObservationDetails: ObPointMeasurementVM[];
  public QuestionFlag: number;
  public FlagColor: string;
  public FlagClearComment: string
  public ClearFlag: boolean;
  public FlagComment: string;

  public updateFlag: boolean = false;
  public AnswerDate: string;
  public QStatus: number;
  public hasCompleteFlag: boolean

  public QCount: number;

}

export class AddCompletedDigitalFormReqVM {
  public Id: number
  public DateCompleted: Date
  public Form: number
  public IncidentId: string
  public IncidentType: number
  public Images: string[]
  public File: string
  public FileName: string
  public RelatedUser: number
  public Notes: string
  public FollowUpRequired: boolean
  public FollowUpCompleted: boolean
  public FollowUpDate: Date
  public FollowUpUser: number
  public QuestionAnsList: DigitalQAnswers[]
  public QuestionImages: DigitalFormQuestionImages[]
  public EditQuestionImages: EditQuestionImages[]
  public SiteId: number
  public FormAnswerComments: string;
  public QuestionComments: DigitalFormQuestionComment[]
  public FormFiles: string[]



}
export class DigitalQAnswers {
  public Qid: number
  public Qtype: number
  public Answers_: string
  public Answers: ModelAnswerList[]
}
export class DigitalFormQuestionImages {
  public qId: number
  public images: string[]
}
export class EditQuestionImages {
  public QId: number
  public QImage: string
}

export class DeleteFormVM {

  public Id: number
}

export class DigitalFormQuestionComment {
  public QuestionId: number
  public Comment: string
}

export class FormsByCategory_Dashboard {
  public Id: number
  public FormName: string
  public RelatedUser: number
  public Date: Date
  public IsDigitalForm: boolean;
  public userName: string
  public FileName: string[]
  public state: string
  public ststeID: number
  public IncidentId: string
  public IncidentName: string
  public isMTI: boolean


}

//Document Library Models
export class GETModels {
  public ID: number
  public modelName: string
}

export class GETDocTpe {
  public ID: number
  public DocType: string
}

export class GETDocStatus {
  public ID: number
  public DocStatus: string
}

export class DocLibraryModelsVM {

  public DocId: number
  public ModelID: number
}
export class DocLibraryVM {
  public Id: number
  public ModelId: number[];
  public ModelIdVM: GETModels[]
  public SerialStart: string
  public SerialEnd: string
  public DocTypeId: number
  public DocHeading: string
  public DocNo: string
  public DocRevNo: string
  public DocStatusId: number
  public StartDate: Date
  public EndDate: Date
  public ImplementId: number
  public ReferenceId: number
  public DocTypeName: string
  public DocStatusName: string
  public ModelNames: string
  public isAddedToAsset: boolean


  public docmuntLibraryModelList: DocLibraryModelsVM[];

  public docAttachments: DocLibraryAttachments[];
}

export class DocLibraryAttachments {
  public Id: number;
  public Attachment: string;
  public DocAttachmentId: number;
  public IsGloble: boolean;
}


export class DocLibraryAuditTrailsVM {


  public DocId: number
  public ModifiedDate: Date
  public ModifiedUserId: number
  public ModifiedUserName: string
  public Action: string
  public FieldName: string
  public OldValue: string
  public NewValue: string

  public ModelId: number[]
  public SerialStart: string
  public SerialEnd: string
  public DocTypeId: number
  public DocHeading: string
  public DocNo: string
  public DocRevNo: string
  public DocStatusId: number
  public StartDate: Date
  public EndDate: Date
  public ImplementId: number
  public ReferenceId: number
  public isAddedToAsset: boolean

}

export class Attachments {
  public Id: number
  public attachment: string
  public attachment_: string
  public DocId: number;
  public isNew: boolean;
  public FileName: string;
}


export class DocLibraryImplmentsVM {
  public ID: number
  public DocId: number
  public DocType: string
  public DocHeading: string
  public DocumentAttachments: DocLibraryAttachmentsVM
  public ModifiedDate: string
  public NoAttchments: number
  public isSelect: boolean
  public ShowReplace: boolean;
}

export class DocLibraryAttachmentsVM {
  public Id: number
  public Attachment: string
  public DocAttachmentId: number
  public IsGloble: boolean
  public DocId: number;
  public ImplementId: number;
  public FileName: string;
}

export class DocLibraryImplementAuditVM {
  public DocId: number
  public ImplementId: number
  public Action: string
  public ModifiedUsedId: number
  public NewAttachment: string
  public OldAttachment: string
  public DocType: string;
  public ImplementSerial: string
  public ModifiedUser: string
  public ActivityDate: string
}

export class PIPStatusVM {
  public Id: number
  public Status: string
}


export class PIPDetailsVM {
  public Id: number
  public ModelId: number[]
  public SerialStart: string
  public SerialEnd: string
  public PIPNo: string
  public PIPHeading: string
  public PIPDescription: string
  public StartDate: Date
  public EndDate: Date
  public PIPStatusID: number
  public supportProgramLevelId: number
  public supportProgramNote: string
  public ModelNames: string
  public PIPStatusName: string
  public SupportProgramLevelName: string
  public currentDate: Date
  public IsExpand: boolean
}


export class PIPSupportProgramLevelsVM {
  public Id: number
  public SupportLevel: string
}


export class PIPSupportDocVM {
  public Id: number
  public PIPId: number
  public attachment_: string
  public FileName: string
  public Extension: string
}

export class PIPImplementsVM {
  public PIPId: number
  public AssetSN: string
  public Type: string
  public TruckModel: number[]
  public TruckModelName: string
  public UnitNo: number
  public Customer: string
  public JobSite: string
  public Status: string
  public statusID: number
}

export class PIPImplmentsLevelVM {
  public Id: number
  public PIPId: number
  public ImplementID: number
  public Status: number
  public StartDate: string
  public completedDate: string
  public PIPNotes: string
  public PIPNumber: string

}

export class PIPImplemetLevelforAsset {
  public ModelId: number[]
  public SerialStart: string
  public SerialEnd: string
  public PIPNo: string
  public PIPHeading: string
  public PIPDescription: string
  public StartDate: Date
  public EndDate: Date
  public PIPStatusID: number
  public supportProgramLevelId: number
  public supportProgramNote: string
  public PIPSupportDocList: PIPImplementAttachmentsVM[]
  public assetPIPStatus: number
  public completedDate: Date
  public assetPIPNotes: string
  public images: string
}

export class PIPImplementAttachmentsVM {
  public Id: number
  public PIPImplementId: number
  public pipId: number
  public ImplementID: number
  public supportDocID: number
  public IsGlobe: boolean
  public attachment: string
  public FileName: string;
}


export class PIPImplementImagesVM {
  public Id: number
  public PIPImpId: number
  public Images: string
}

export class PIPImplementAuditTrailVM {
  public PIPImplementId: number
  public Action: string
  public ModifiedDate: Date
  public ModifieUserName: string
  public oldValue: string
  public newValue: string
  public supportProgramNote: string
  public assetPIPStatus: number
  public CompletedDate: Date
  public AssetPIPNote: string
  public AssetSN: string
}



export class userAlertsVM {
  public ID: number
  public user_auto: number
  public Source: string
  public CreatedDate: Date
  public description: string
  public status: number
  public Link: string
  public isHistory: boolean
  public ImpName: string
  public EqUnitNo: string
}

export class GETObservationListVM {
  public name: string
  public observationList_auto: number
  public customerID: number
  public numberOfObservations: number
  public CrackSeverityList: boolean
  public active: boolean
  public ObservatoinName: string[]
  public FamId: number
  public FamName: string
  public CrackObsList: boolean;
}

export class GETObservationsCusVM {
  public observation_list_auto: number
  public observation_auto: number
  public observation: string
  public active: boolean
  public observationListname: string
  public FamId: number
  //public isNew: boolean
  public ColorCode: string
  public ColorIncludeInReport: boolean
}


export class userAlertsVMDigitalForms {
  public ID: number
  public user_auto: number
  public Source: string
  public CreatedDate: Date
  public description: string
  public status: number
  public Link: string
  public isHistory: boolean
  public FormName: string
  public EquipmentName: string
}

export class PolicyDetailsVM {
  public PolicyId: number
  public PolicyName: string
  public DepartmentIds: number[]
  public StateIds: number[]
  public WorkAreaIds: number[]
  public Note: string
  public IssuedDate: Date
  public ExpiredDate: Date
  public CreatedDate: Date
  public Attachment: string
  public FileName: string
  public SiteNames: string
  public DepartmentNames: string
  public WorkAreaNames: string
  public EndDate: Date
  public IsExpand: boolean
  public policyProcedureAuditTrailsVM: PolicyProcedureAuditTrailsVM[]
}

export class PolicyProcedureAuditTrailsVM {
  public PolicyID: number
  public Action: string
  public ModifiedDate: Date
  public ModifiedUserName: string
  public OldValue: string
  public FieldName: string
  public NewValue: string
}


export class LeavesTypesVM {
  public Id: number;
  public Name: string;
}

export class LeavesStatusVM {
  public Id: number;
  public Status: string;
}

export class NewLeaveInfo {
  public Id: number;
  public LeaveFrom: Date
  public LeaveTo: Date
  public LeaveTypeId: number
  public StateId: number
  public DepartmentId: number
  public Attachment: string;
  public Extention: string;
  public Note: string;

  public RequestedUserId: number
  public RequestedUser: string;

  public ApprovedUserId: number
  public ApprovedUser: string;

  public StatusId: number;

  public Status: string;
  public LeaveType: string;
  public IsExpand: boolean;
  public LeaveFrom_: any
  public LeaveTo_: any
  public DepartmentName: string;
  public StateName: string;

  public LeaveAuditTrail: LeaveRequestAuditTrail[];
}
export class LeaveRequestAuditTrail {
  public Id: number
  public LeaveReqId: number
  public ActionDate: Date
  public Action: string
  public UserName: string
  public FieldChange: string
  public ChangeFrom: string
  public ChangeTo: string
}

export class DispalyMultiselect {
  public display: string;
  public Value: string;
}
